module.exports = "/fonts/PT Root UI_Bold.woff2?ee168f16fed9c73504698df2ee951517";